export enum CompanyEnum {
    ToT = 1,
    TEACH = 2
}